// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__GPBei","form":"styles_form__Ks6QW"};